export const TEST_REPORT_ACTION_TYPE = {
  GET_TEST_REPORT_LIST_SUCCESS: 'GET_TEST_REPORT_LIST_SUCCESS',
  UPDATE_TEST_REPORT_LIST_SUCCESS: 'UPDATE_TEST_REPORT_LIST_SUCCESS',
  GET_TEST_REPORT_DETAIL_SUCCESS: 'GET_TEST_REPORT_DETAIL_SUCCESS',
  GET_TEST_REPORT_PENDING_TEST_COUNT: 'GET_TEST_REPORT_PENDING_TEST_COUNT',
  GET_TEST_REPORT_HEADER_STAT: 'GET_TEST_REPORT_HEADER_STAT'
};
